module.exports = __webpack_public_path__ + "static/media/HCMM073.8be3b9d7.jpg";